import 'babel-register';
import 'babel-polyfill';
import { ThemeProvider } from 'styled-components';
import ReactDOM from 'react-dom';
import React from 'react';
import { Alexa, HeaderSimple, FooterSimple } from 'hui/dist/styled/';
import { Theme } from 'hui/dist/styled/theme';

export class AlexaPage {
  constructor(element) {
    ReactDOM.render(
      <ThemeProvider theme={Theme}>
        <div>
          <HeaderSimple siteSource="Alexa Page" />
          <Alexa />
          <FooterSimple siteSource="Alexa Page" />
        </div>
      </ThemeProvider>, element);
  }
}

window.AlexaPage = AlexaPage;



// WEBPACK FOOTER //
// ./alexa-page/index.js